const CARD_TITLE_WIDTH = Object.freeze({
  S: '58%',
  M: '70%',
  L: '82%',
  WIDE: '55%',
});

export function getCardTitleImageWidth(cardSize = 'M') {
  const normalized = String(cardSize || 'M').toUpperCase();
  return CARD_TITLE_WIDTH[normalized] || CARD_TITLE_WIDTH.M;
}

export { CARD_TITLE_WIDTH };
